// extracted by mini-css-extract-plugin
module.exports = {"container":"_2XfHu","header":"_1g8aC","menu":"_3LWoY"};